import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/my-components/(pages)/(list)')({
  component: lazyRouteComponent(
    () => import('../../-components/MyComponentsLayout'),
    'MyComponentsLayout',
  ),
});
